import React from "react";
import styled from "@emotion/styled";

import TooltipComponent from "components/ui/tooltip/Tooltip";
import { NoticesStagesv2 } from "lib/types/graphQLEnums";
import { tenderStages } from "lib/types/models";
import { Flex, Text } from "../../styles/utility-components";

type NoticeStageProps = {
  stage?: NoticesStagesv2;
  onClick?: () => void;
} & Omit<React.ComponentPropsWithoutRef<typeof StageSelectTagContainer>, "color">;

function NoticeStage({ stage, ...props }: NoticeStageProps) {
  const stageDetails = tenderStages[stage ?? NoticesStagesv2.UnknownTender];
  return (
    <TooltipComponent content={<Text>{stageDetails.tooltip}</Text>}>
      <StageSelectTagContainer color={stageDetails.color} {...props}>
        {stageDetails.label}
      </StageSelectTagContainer>
    </TooltipComponent>
  );
}

export const StageSelectTagContainer = styled(Flex)<{ color: string }>(({ color, theme }) => ({
  display: "flex",
  alignItems: "center",
  color: theme.colors.sysTextDefault,
  gap: 8,
  width: "fit-content",
  minHeight: 26,
  padding: "2px 8px",
  backgroundColor: `${color}1A`, // 1A = 10% opacity
  borderRadius: 2,
  borderLeft: `2px solid ${color}`,
}));

export default NoticeStage;
